/**
 * Gera um identificador único compatível com ambientes sem crypto.randomUUID (ex.: WebViews antigos).
 * @param {string} [prefix='id']
 * @returns {string}
 */
export function generateId(prefix = 'id') {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
